import { View } from "@-/com.npmjs.react-native";
import type { ScrollEdgeElementContainerProps } from "#scroll-edge-element-container-types";

/** Browsers have no scroll edge effect: the container is a plain view. */
export function ScrollEdgeElementContainer({
  coversBounds: _coversBounds,
  edge: _edge,
  hideScrollEdgeEffect: _hideScrollEdgeEffect,
  revision: _revision,
  scrollerScope: _scrollerScope,
  ...props
}: ScrollEdgeElementContainerProps) {
  return <View {...props} />;
}
